import React, { useRef } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './VideoCarousel.css';
import VideoWithSpinner from './VideoWithSpinner';


const VideoCarousel = ({
  videos = [
    { src: '/videos/gestures_mike.mp4' },
    { src: '/videos/gestures_chess.mp4' },
    { src: '/videos/gestures_vim.mp4' },
    { src: '/videos/gestures_car.mp4' },
  ],
  mainTitle = 'Control your computer with face gestures',
  subTitle = 'No need for a mouse, a keyboard, or any additional hardware. Use only face gestures to take full control of your computer.',
}) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <div className="chunk-container">
      <div className="chunk-content">
        <h1 className="main-title">{mainTitle}</h1>
        <p className="sub-title">{subTitle}</p>
        <Slider ref={sliderRef} {...settings}>
          {videos.map((video, index) => (
            <div key={index}>
              <VideoWithSpinner
                src={video.src}
                muted
                autoPlay
                playsInline
                loop
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

VideoCarousel.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
    })
  ),
  mainTitle: PropTypes.string,
  subTitle: PropTypes.string,
};

export default VideoCarousel;
